<template>
  <div id="app" v-cloak>
    <notifications group="notification" position="top right" class="noprint">
      <template slot="body" slot-scope="props">
        <div class="vue-notification bounceIn p-2 shadow-sm mt-1" :class="props.item.type">
          <a class="title">{{props.item.title}}</a>

          <a class="notification-close pointer" @click="props.close">
            <v-icon>mdi-close</v-icon>
          </a>
          <div v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>

    <notifications group="add_item_invoice_notification" position="bottom center" class="noprint">
      <template slot="body" slot-scope="props">
        <div class="add_invoice_notify p-2 shadow-sm mt-1" :class="props.item.type">
          <a class="title">{{props.item.title}}</a>
          <div v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>



    <!-- <notifications group="firestore" position="top right" class="notification noprint">
      <template slot="body" slot-scope="props">
        <div class="text-center p-2">
          <a class="title">{{props.item.title}}</a>
          <a class="close" @click="props.close">
            <icon icon="x-circle" />
          </a>
          <div v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>-->
    <transition name="page" mode="out-in">
      <component :is="layout" v-if="layout" />
    </transition>
  </div>
</template> 
<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
[v-cloak] {
    display: none !important;
}

// .vue-notification {
//   color: black;
//   border-radius: 5px;
//   // background: #d1d8ab;
//   margin-top: 10px;
//   &.warn {
//     background: #ffb648;
//     border-left-color: #f48a06;
//   }

//   &.error {
//     background: #e54d42;
//     border-left-color: #b82e24;
//   }

//   &.success {
//     background: #68cd86;
//     border-left-color: #42a85f;
//   }
// }
.add_invoice_notify {
  padding: 10px;
  margin: 0 5px 5px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 15px !important;
  color: #ffffff;
  background: black;
  border-left: 2px;
  text-align: center;
  width: 170px;
}
.notification-close {
  float: right;
  color: #ffffff;
}
.vue-notification {
  padding: 10px;
  margin: 0 5px 5px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 15px !important;
  color: #ffffff;
  background: #44a4fc;
  border-left: 2px;

  &.warn {
    background: #ffb648;
    border-left: 2px;
    // border-left-color: #f48a06;
  }
  &.info {
    border-left: 2px;
  }

  &.error {
    background: #e54d42;
    border-left: 2px;
    // border-left-color: #b82e24;
  }

  &.success {
    border-left: 2px;
    background: #2d9344;
    // border-left-color: #42a85f;
  }
}
.bounceIn {
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style> 
<script>
import store from "@/store";
const requireContext = require.context("./layouts", false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});
export default {
  name: "App",
  metaInfo: {
    title: "DiscoverLao Cashier"
  },
  data: () => ({
    layout: null,
    defaultLayout: "default"
  }),
  computed: {
    user() {
      return store.getters["auth/user"];
    }
  },

  mounted() {
    this.firestore();
  },
  methods: {
    async firestore() {

    },
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }
      this.layout = layouts[layout];
    },

  }
};
</script>

 